import { FC } from 'react';
import { PrivacyListType } from 'types/types';

interface IPrivacyPolicyItem {
  title: string,
  privacyPolicies?: PrivacyListType[]
}
const PrivacyPolicyItem: FC<IPrivacyPolicyItem> = ({
  title,
  privacyPolicies,
}) => {
  
  return (
    <div className='privacy-policy-list'>
      <h5 className='privacy-policy-list_title'>{title}</h5>
      {privacyPolicies && privacyPolicies.map((listItem, index) => (
        <div key={index} className="privacy-policy-list_item">
            <div className="privacy-policy-list_description">
              {listItem.description}
            </div>
            <ol>
              {listItem.innerList && listItem.innerList.map((item, index) => (
                <li key={index}>
                  {item.description}
                </li>
              ))}
            </ol>
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicyItem;
